// extracted by mini-css-extract-plugin
module.exports = {"walletButton":"wallet-menu_walletButton__1rvLF"};